export enum TabType {
    General,
    ProfessionalInfo,
    Schedule,
    Services,
    Commissions,
    Permissions
}